module.exports = __webpack_public_path__ + "static/media/passport-sample.1e0ce7b6.png";